import { render, staticRenderFns } from "./VeJwCjZhiyeList.vue?vue&type=template&id=2adfbe1c&scoped=true"
import script from "./VeJwCjZhiyeList.vue?vue&type=script&lang=js"
export * from "./VeJwCjZhiyeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adfbe1c",
  null
  
)

export default component.exports